import { useRecoilValue } from 'recoil'
import { CSSProperties, useMemo } from 'react'
import { IOption } from '@/types/global.ts'
import { IEquipment } from '@/pages/Equipment/equipment.types.ts'
import MultiDropdownInput, { TMultiDropdown } from '@/shared/Inputs/MultiDropdownInput'
import equipmentAtom from '@/pages/Equipment/atoms/equipment.atom.ts'
import equipmentUtils from '@/pages/Equipment/equipment.utils.ts'

interface IProps {
  selected: IEquipment['id'][]
  onSelect: (modelIds: IEquipment['id'][], name: string) => void
  name: string
  title?: string
  type?: TMultiDropdown
  panelStyle?: CSSProperties
}

const EquipmentMultiSelect = (props: IProps) => {
  const equipment = useRecoilValue(equipmentAtom).items

  const options: IOption<IEquipment['id']>[] = useMemo(() => {
    return equipment.map((e) => ({ title: equipmentUtils.getEquipmentAddress(e.location), value: e.id }))
  }, [equipment])

  return (
    <MultiDropdownInput
      options={options as any}
      onSelect={props.onSelect}
      title={props.title || 'Выберите из списка'}
      selectedOptions={props.selected as any}
      name={props.name}
      panelStyle={props.panelStyle}
      type={props.type || 'input'}
    />
  )
}

export default EquipmentMultiSelect
